import { NgIf, AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DataViewGraphDetailedComponent } from './data-view-graph-detailed/data-view-graph-detailed.component';
import { DataViewGraphSimpleComponent } from './data-view-graph-simple/data-view-graph-simple.component';
import { DataViewTableDetailedComponent } from './data-view-table-detailed/data-view-table-detailed.component';
import { DataViewTableSimpleComponent } from './data-view-table-simple/data-view-table-simple.component';
import { FarmerInsightsModuleState, ViewMode } from '../../models/farmer-insights.model';
import {
  getIsDetailedModeSelected,
  getSelectedViewMode,
} from '../../store/selectors/farmer-insights.selectors';

@Component({
  selector: 'app-data-view',
  templateUrl: './data-view.component.html',
  imports: [
    NgIf,
    DataViewTableSimpleComponent,
    DataViewGraphSimpleComponent,
    DataViewTableDetailedComponent,
    DataViewGraphDetailedComponent,
    AsyncPipe,
  ],
})
export class DataViewComponent {
  private readonly store = inject<Store<FarmerInsightsModuleState>>(Store);

  public viewModes = ViewMode;
  public selectedViewMode$: Observable<ViewMode> = this.store.select(getSelectedViewMode);
  public isDetailedModeSelected$: Observable<boolean> =
    this.store.select(getIsDetailedModeSelected);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);
  constructor() {}
}
